class GlobalReactService {
  appID: string = process.env.APP_ID || ''
  defaultSubDomain: string = process.env.DEFAULT_SUBDOMAIN || 'admin'
  lmsApp: string = process.env.LMS_APP || ''
  lmsApi: string = process.env.LMS_API || process.env.REACT_APP_LMS_API || ''
}

export const globalReactService = new GlobalReactService()
